import { boot } from 'quasar/wrappers'
import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getDatabase } from 'firebase/database'
import { getAuth } from 'firebase/auth'
import { Platform } from 'quasar'
import 'firebase/firestore'

const env = import.meta.env

const config = {
	apiKey: process.env.FIRE_API_KEY,
	authDomain: process.env.FIRE_AUTH_DOMAIN,
	databaseURL: process.env.FIRE_DATABASE_URL,
	projectId: process.env.FIRE_PROJECT_ID,
	storageBucket: process.env.FIRE_STORAGE_BUCKET,
	messagingSenderId: process.env.FIRE_MESSAGING_SENDER_ID,
}

export const app = initializeApp(config)
export const db = getFirestore(app)
export const fb = getDatabase(app)

export default boot(({ app }) => {
	if (!Platform.is.capacitor) {
		app.config.globalProperties.$webAuth = getAuth()
	}
})
